// extracted by mini-css-extract-plugin
export default {"progress-list-wrapper":"progress-list-wrapper-3dc2"};